import { BoxContainer, H2 } from '@welcom/esg-react-components'
import React from 'react'

export const Thanks = () => (
   <BoxContainer>
      <H2>Thanks!</H2>
      <p>
         Your application is now submitted. An email has been sent to you with
         the application information
      </p>
   </BoxContainer>
)
